import Container from '@/components/atoms/container/container'
import Footer from '@/components/organisms/footer/footer'
import Header from '@/components/organisms/header/header'
import PaymentComplete from '@/components/templates/paymentInProgress/components/paymentComplete'

export default function LoadingScreenDebugPage() {
    return (
        <Container isFullHeight={true}>
            <Header />
            <PaymentComplete mode="processing" />
            <Footer />
        </Container>
    )
}
